import { axiosPrivate } from "@/api/axios";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";

export default function useCategories() {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["categories"], // keep cache key stable for now
    queryFn: async (): Promise<{ id: number; name: string; description?: string; icon_url?: string }[]> => {
      const response = await axiosPrivate.get("/feeds/categories");
      if (!response.data.success) {
        toast.error("Failed to fetch feed categories. Please try again later.");
        throw new Error("Failed to fetch feed categories.");
      }
      return response.data.data;
    },
  });

  return { data, isLoading, isError, error };
}
